import { HeroSection } from "../components/HeroSection";
import { ProblemSection } from "../components/ProblemSection";
import { SolutionSection } from "../components/SolutionSection";
import { WhyUsSection } from "../components/WhyUsSection";
import { ServicesGrid } from "../components/ServicesGrid";
import { CaseStudySection } from "../components/CaseStudySection";
import { PricingSection } from "../components/PricingSection";
import { ChecklistPreviewSection } from "../components/ChecklistPreviewSection";
import { CtaSection } from "../components/CtaSection";
import { ContactForm } from "../components/ContactForm";

export function HomePage() {
  return (
    <main id="main-content" tabIndex={-1}>
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <WhyUsSection />
      <ServicesGrid />
      <CaseStudySection />
      <PricingSection />
      <ChecklistPreviewSection />
      <CtaSection />
      <ContactForm />
    </main>
  );
}
